export const ACCEPT_ALL = "accepted_all";
export const ESSENTIAL_ONLY = "essential_only";
export const TRACKING_VIA_OPTIN = "tracking_via_optin";

let pageCookieChoice = null;

export const normalizeCookieChoice = (choice) => {
  if (choice === "acceptAll" || choice === ACCEPT_ALL) return ACCEPT_ALL;
  if (choice === "rejected" || choice === "essential" || choice === ESSENTIAL_ONLY || choice === TRACKING_VIA_OPTIN) return ESSENTIAL_ONLY;
  return null;
};

const currentLinkToken = () => window?.objInit?.tlb?.token;

export const setCookieChoice = (choice) => {
  pageCookieChoice = normalizeCookieChoice(choice);
  if (window?.objInit?.session) {
    window.objInit.session.cookie_status = pageCookieChoice;
  }
};

export const removeLegacyCookieChoiceStorage = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key === "cookiesPrivacy" || key.startsWith("cookiesPrivacy:"))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    return;
  }
};

export const isCookieConsentRequired = () => !!window?.objInit?.tlb?.privacy_policy_consent;

export const isCookieBannerEnabled = () => isCookieConsentRequired();

export const getCookieChoice = () => {
  return normalizeCookieChoice(window?.objInit?.session?.cookie_status) || pageCookieChoice;
};

export const hasCookieChoice = () => !isCookieBannerEnabled() || !!getCookieChoice();

export const isSenderContext = () => !!window?.kzSenderConsent;

export const getSenderChoice = () => normalizeCookieChoice(window?.kzSenderConsent?.status);

export const setSenderChoice = (choice) => {
  if (!isSenderContext()) return;
  window.kzSenderConsent.status = normalizeCookieChoice(choice);
  window.dispatchEvent(new CustomEvent("cookieConsentChanged", { detail: { cookieStatus: window.kzSenderConsent.status } }));
};

const isRecipientAcceptAll = () => getCookieChoice() === ACCEPT_ALL || (!isCookieConsentRequired() && !getCookieChoice());

export const isAcceptAll = () => (isSenderContext() ? getSenderChoice() === ACCEPT_ALL : isRecipientAcceptAll());

export const isTrackingAllowed = () => isRecipientAcceptAll();

export const shouldShowEmbeddedContent = () => {
  if (isSenderContext()) return isAcceptAll();
  if (window?.objInit === undefined) return false;
  return isAcceptAll();
};

export const getCookieConsentStatus = () => getCookieChoice() || null;

export const isExternalUrl = (url) => {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (!trimmed || /^(data:|blob:)/i.test(trimmed)) return false;
  try {
    return new URL(trimmed, window.location.href).origin !== window.location.origin;
  } catch (error) {
    return false;
  }
};

const writeOrRemove = (key, value) => {
  if (value && Object.keys(value).length > 0) localStorage.setItem(key, JSON.stringify(value));
  else localStorage.removeItem(key);
};

export const clearOptionalStorage = (token = currentLinkToken()) => {
  if (!token) return;
  try {
    localStorage.removeItem(`session_refresh_${token}`);
    localStorage.removeItem(`optin_pages_${token}`);
    const lastSeen = JSON.parse(localStorage.getItem("lastSeenPage") || "{}");
    if (lastSeen && Object.prototype.hasOwnProperty.call(lastSeen, token)) {
      delete lastSeen[token];
      writeOrRemove("lastSeenPage", lastSeen);
    }
    ["receiver", "optin"].forEach((key) => {
      const persistent = JSON.parse(localStorage.getItem(key) || "{}");
      if (persistent && Object.prototype.hasOwnProperty.call(persistent, token)) {
        const session = JSON.parse(sessionStorage.getItem(key) || "{}") || {};
        session[token] = persistent[token];
        sessionStorage.setItem(key, JSON.stringify(session));
        delete persistent[token];
        writeOrRemove(key, persistent);
      }
    });
  } catch (error) {
    return;
  }
};
